/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSidebarSellerInfoAndContactLazy_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfoAndContact_user">;
    readonly " $refType": "PdpRespSidebarSellerInfoAndContactLazy_user";
};
export type PdpRespSidebarSellerInfoAndContactLazy_user$data = PdpRespSidebarSellerInfoAndContactLazy_user;
export type PdpRespSidebarSellerInfoAndContactLazy_user$key = {
    readonly " $data"?: PdpRespSidebarSellerInfoAndContactLazy_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfoAndContactLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContact_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'd3950256262cebedafb92a27120cdb69';
export default node;
